import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import SolicitacaoService from '../../../../services/solicitacao';

export default function FormSolicitacao({ show, onHide, carrinho, onSucesso }) {
    const [sucesso, setSucesso] = useState(false)
    const [id, setId] = useState("");
    const [dados, setDados] = useState({
        secretaria: '',
        responsavel: '',
        email: '',
        numeroMemorando: ''
    });

    const resetForm = () => {
        setSucesso(false);
        setId("");
        setDados({
            secretaria: '',
            responsavel: '',
            email: '',
            numeroMemorando: ''
        });
    };

    const submit = async () => {
        const payload = { ...dados, componentes: carrinho };
        const res = await SolicitacaoService.cadastro(payload);

        setId(res.data["_id"]);
        setSucesso(true);

        if (onSucesso) {
            onSucesso();
        }
    };

    if (!sucesso) {
        return (
            <Modal show={show} onHide={onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>Dados da Solicitação</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Select
                            onChange={e => setDados({ ...dados, secretaria: e.target.value })}
                        >
                            <option>SELECIONE</option>
                            <option value="Secretaria Municipal de Segurança Pública, Administração e Mobilidade Urbana">Segurança Pública, Administração e Mobilidade Urbana</option>
                            <option value="Secretaria Municipal de Agricultura, Pecuária, Abastecimento e Aquicultura">Agricultura, Pecuária, Abastecimento e Aquicultura</option>
                            <option value="Secretaria Municipal de Educação">Educação</option>
                            <option value="Secretaria Municipal de Esporte, Lazer, Turismo e Cultura">Esporte, Lazer, Turismo e Cultura</option>
                            <option value="Secretaria Municipal de Fazenda, Planejamento, Orçamento, Indústria e Comércio">Fazenda, Planejamento, Orçamento, Indústria e Comércio</option>
                            <option value="Secretaria Municipal de Gabinete e Comunicação">Gabinete e Comunicação</option>
                            <option value="Secretaria Municipal de Controle Interno">Controle Interno</option>
                            <option value="Secretaria Municipal de Governo e Gestão">Governo e Gestão</option>
                            <option value="Secretaria Municipal de Meio Ambiente, Urbanismo e Defesa Civil">Meio Ambiente, Urbanismo e Defesa Civil</option>
                            <option value="Secretaria Municipal de Obras e Serviços Públicos">Obras e Serviços Públicos</option>
                            <option value="Secretaria Municipal de Saúde e Prevenção à Dependência Química">Saúde e Prevenção à Dependência Química</option>
                            <option value="Secretaria Municipal de Desenvolvimento Social e Direitos Humanos">Desenvolvimento Social e Direitos Humanos</option>
                            <option value="Secretaria Municipal de Trabalho, Envelhecimento Saudável e da Juventude">Trabalho, Envelhecimento Saudável e da Juventude</option>
                            <option value="Departamento de Patrimônio">Patrimônio</option>
                            <option value="Departamento de Turismo">Turismo</option>
                            <option value="Departamento de Cultura">Cultura</option>
                            <option value="Junta Militar de Macuco">Junta Militar de Macuco</option>
                        </Form.Select>

                        <Form.Control
                            className="mt-2"
                            placeholder="Responsável"
                            onChange={e => setDados({ ...dados, responsavel: e.target.value })}
                        />

                        <Form.Control
                            className="mt-2"
                            type="email"
                            placeholder="E-mail"
                            onChange={e => setDados({ ...dados, email: e.target.value })}
                        />

                        <Form.Control
                            className="mt-2"
                            placeholder="Memorando/Ano"
                            onChange={e => setDados({ ...dados, numeroMemorando: e.target.value })}
                        />
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={submit}>Enviar Solicitação</Button>
                </Modal.Footer>
            </Modal>
        );
    } else {
        return (
            <Modal show={show} onHide={onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>Solicitação Cadastrada com sucesso!</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Alert variant="success">Sua solicitação foi enviada e o número dela é: <strong>{id}</strong> . <br />
                        Use esse número para consultar sua situação futuramente.
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="success"
                        onClick={() => {
                            resetForm();
                            onHide();
                        }}
                    >
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

